import { apiService as api } from './api';
import { RespostaPaginada, VeiculoMarca, VeiculoModelo } from '../types';

/**
 * Catálogo de marcas e modelos de veículo, por empresa.
 *
 * O cadastro tem três desfechos possíveis, e a tela precisa distinguir os três:
 * criado (201), já existia com outra grafia (200 com `ja_existia`), ou parecido
 * com algo que já existe (409). O último é o que impede o catálogo de encher de
 * "Volksvagen" ao lado de "Volkswagen".
 */

export interface RespostaDeCadastro<T> {
  success: boolean;
  message?: string;
  /** Verdadeiro quando o nome já existia e o servidor devolveu a entrada existente. */
  ja_existia?: boolean;
  data: T;
}

/** Corpo do 409: o servidor achou nomes parecidos e quer uma decisão. */
export interface ConflitoDeNomeParecido {
  codigo: 'nome_parecido';
  message: string;
  data: {
    nome_solicitado: string;
    sugestoes: Array<{ id: number; nome: string }>;
  };
}

export const catalogoVeiculosService = {
  listarMarcas: async (busca?: string, perPage = 100) => {
    const params = new URLSearchParams({ per_page: String(perPage) });
    if (busca) params.append('busca', busca);
    return api.get<RespostaPaginada<VeiculoMarca>>(`/v1/veiculos/marcas?${params}`);
  },

  // `confirmar` só dispensa a checagem de nome parecido. A de nome idêntico roda
  // sempre, então nenhum caminho da tela consegue criar duplicata exata.
  criarMarca: async (nome: string, confirmar = false) =>
    api.post<RespostaDeCadastro<VeiculoMarca>>('/v1/veiculos/marcas', { nome, confirmar }),

  listarModelos: async (marcaId: number, busca?: string, perPage = 100) => {
    const params = new URLSearchParams({ per_page: String(perPage) });
    if (busca) params.append('busca', busca);
    return api.get<RespostaPaginada<VeiculoModelo>>(`/v1/veiculos/marcas/${marcaId}/modelos?${params}`);
  },

  criarModelo: async (marcaId: number, nome: string, confirmar = false) =>
    api.post<RespostaDeCadastro<VeiculoModelo>>(`/v1/veiculos/marcas/${marcaId}/modelos`, { nome, confirmar }),
};
